import {Col, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  handleDefaultValues,
} from "../../common/Utils";
import {useForm} from 'react-hook-form';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {addToCart, getInventoryEvent} from "../../common/api/PortalCustomerApi";
import Meta from "../../common/Meta";
import {Card, CardContent, Divider, Grid} from "@mui/material";
import {addtoWaitlist} from "../../common/api/CartApi";
import CustomerPageLayout from "../../Layout/CustomerPageLayout";
import CustomerHeader from "../../common/CustomerHeader";
import MDBox from "../../../components/MDBox";
import Footer from "../../Footer";
import {CartContext} from "../../../lib/CartProvider";
import {UserContext} from "../../../lib/UserProvider";
import EventDetail from "./EventDetail";
import {CompanyContext} from "../../../lib/CompanyProvider";

export default function CustomerViewEvent(props) {
  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  const [cartContext, setCartContext] = useContext(CartContext);
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [userContext, setUserContext] = useContext(UserContext);

  const [company, setCompany] = useState(companyContext?.company);
  const location = useLocation();
  let {eventId} = useParams();
  const [eventReady, setEventReady] = useState(false);
  const [event, setEvent] = useState();

  const onAccountChange = (props) => {
  }
  const [pageReady, setPageReady] = useState(false);
  useEffect(() => {
    if (companyContext?.company?.guid) {
      setPageReady(true);
      setCompany(companyContext?.company);
    }
  }, [companyContext?.company]);

  useEffect(() => {
    if (!pageReady) {
      return;
    }
    getInventoryEventFn();
  }, [pageReady, eventId]);

  const getInventoryEventFn = async () => {
    getInventoryEvent(eventId).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEvent(result);
        setEventReady(true);
      }
    });
  }

  const [inventoryType, setInventoryType] = useState();
  const [formInvalid, setFormInvalid] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(inventoryType)
  });

  const handleClose = () => {
    if (props.handleSave) {
      props.handleSave();
    }
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  const viewEvent = (e) => {
    navigate('/cx/register/' + e.guid);
  };

  const addToCartFn = async (e) => {
    addToCart(event).then(resp => {
      handleClose();
      setCartContext({cartContext, reloadCart: true, viewCart: true});
    });
  };

  const addToWaitlistFn = async (e) => {
    if (!context?.sessionUser?.guid) {
      setUserContext({...userContext, showLogin: true});
      return;
    }
    addtoWaitlist(event).then(resp => {
      handleClose();

      setCartContext({...cartContext, reloadCart: true});

      let _context = {...context};
      _context.toast = {
        message: 'Added to Event Wait List!',
      }
      setContext({..._context});
    });
  };

  return (

    <>
      <CustomerPageLayout>

        <CustomerHeader props={props}/>

        <Meta pageTitle={(event?.name || 'Event') + ' Registration'}/>

        <Grid container>
          <Grid item xs={12} sm={12}>
            <MDBox py={2}>
              {eventReady &&

                <MDBox py={2} m={1}>
                  <Card>
                    <CardContent>
                      <EventDetail
                        showRegistration={true}
                        showDesc={true}
                        event={event}
                        full={true}
                        embedded={props?.embedded}
                        callback={() => {
                        }}
                        packages={false}/>
                    </CardContent>
                  </Card>
                </MDBox>
              }
            </MDBox>
          </Grid>
        </Grid>

        <Footer/>
      </CustomerPageLayout>
    </>
  );
}